<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div class="bg-cover" :style="'background-image: url(' + $asset('/hkcm/images/auth.png', 'public') + ')'">
            <div class="min-h-screen container mx-auto flex items-center justify-center">
                <div class="bg-white lg:w-1/2 rounded-md my-12">
                    <!-- Prominent login headline START-->
                    <!-- <div class="bg-red text-white rounded-md w-full p-2 mb-8">
                        <p>
                            <strong>Für Bestandskunden:</strong>
                            <br/>
                            Bitte benutzen Sie beim erstmaligen Einloggen die „Passwort vergessen“-Funktion und legen Sie ein neues Passwort fest um zu Ihrem Dashboard zu gelangen.
                        </p>
                    </div> -->
                    <!-- Prominent login headline END-->

                    <div v-if="activeTab != 'reset-password'" class="flex flex-col lg:flex-row">
                        <div
                            :class="activeTab === 'login' ? 'bg-white text-blue-dark w-full lg:w-3/5' : 'bg-blue-dark text-white w-full lg:w-2/5'"
                            class="mx-auto w-full transition-all ease-in-out duration-300 rounded-md p-4 flex flex-col justify-center items-center"
                        >
                            <div>
                                <div class="text-center mb-8">
                                    <h3 class="large_normal uppercase text-blue">
                                        {{ $t('already_registered') }}
                                    </h3>
                                    <h1 class="xl3_bold">{{ $t('account_login') }}</h1>
                                    <h2 class="base_normal">
                                        {{ $t('account_login_leading') }}
                                    </h2>
                                </div>

                                <Login ref="login" :showLinks="false">
                                    <template #section-0>
                                        <router-link @click="transferEmail" :to="{ name: 'forgot-password' }" class="block mt-2 text-blue">
                                            <span>
                                                {{ $t('forgot_password') }}
                                            </span>
                                        </router-link>
                                    </template>
                                </Login>
                            </div>

                            <!-- Currently it is not possible to register if you are not on Checkout -->
                            <!-- <div v-else>
                                <div class="text-center">
                                    <h6 class="uppercase hidden lg:block">
                                        {{ $t('Already registered?') }}
                                    </h6>
                                    <h3>
                                        {{ $t('account_login') }}
                                    </h3>
                                    <p class="hidden lg:block">
                                        {{ $t('login_leading') }}
                                    </p>
                                </div>

                                <FormButton class="my-6"
                                    styling="primary flex items-center gap-3 border border-white mx-auto"
                                    @click="activeTab = 'login'"
                                    :value="$t('account_login')">
                                </FormButton>
                            </div> -->
                        </div>
                        <!-- Currently it is not possible to register if you are not on Checkout -->
                        <!-- <div :class="activeTab === 'register' ? 'bg-white text-blue-dark w-full lg:w-3/5' : 'bg-blue-dark text-white w-full lg:w-2/5'"
                            class="mx-auto w-full transition-all ease-in-out duration-300 rounded-md p-4 lg:p-16 flex flex-col justify-center items-center">

                            <div v-if="activeTab === 'register'">
                                <div class="text-center mb-8">
                                    <h6 class="uppercase text-blue">
                                        {{ $t('Welcome to HKCM') }}
                                    </h6>
                                    <h3>{{ $t('plain_register') }}</h3>
                                    <p>
                                        {{ $t('register_leading') }}
                                    </p>
                                </div>

                                <Register :showLinks="false"/>
                            </div>

                            <div v-else>
                                <div class="text-center">
                                    <h6 class="uppercase hidden lg:block">
                                        {{ $t('Welcome to HKCM') }}
                                    </h6>
                                    <h3>{{ $t('plain_register') }}</h3>
                                    <p class="hidden lg:block">
                                        {{ $t('register_leading') }}
                                    </p>
                                </div>
                                <FormButton class="my-6"
                                    styling="primary flex items-center gap-3 border border-white mx-auto"
                                    @click="activeTab = 'register'"
                                    :value="$t('plain_register')">
                                </FormButton>
                            </div>

                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data: () => ({
        activeTab: 'login'
    }),
    mounted() {
        this.activeTab = this.$route.name;
    },
    methods: {
        transferEmail() {
            this.$refs.login.SaveEmailToUrl();
        }
    }
};
</script>
